import React from "react";
import ViewLogo from "../../assets/view-icon.png";
import LedgerIcon from "../../assets/ledger.png";
import { BsThreeDots } from "react-icons/bs";
import { Popup } from "@progress/kendo-react-popup";
import styles from "../Matters/Matter.module.scss";

const List = ({ imageSrc, name, onClick }) => (
  <div
    className={`${styles["list-item"]} flex align-items-center justify-content-start px-3 py-2 cursor-pointer`}
    onClick={onClick}
    role="button">
    <img role="button" src={imageSrc} alt="" style={{ marginRight: "10px" }} />
    <span role="button" style={{ fontWeight: "600", fontSize: "12px" }}>
      {name}
    </span>
  </div>
);

export const TransactionSearchOptionsList = ({
  handleOptionClick,
  handleCellClick,
  selectedCell,
  ...props
}) => (
  <>
    <List
      imageSrc={ViewLogo}
      name="View Details"
      onClick={() => {
        handleOptionClick("viewDetails", selectedCell || props);
        handleCellClick(null);
      }}
    />
    <List
      imageSrc={LedgerIcon}
      name="View Ledger"
      onClick={() => {
        handleOptionClick("viewLedger", selectedCell || props);
        handleCellClick(null);
      }}
    />
  </>
);

export const TransactionSearchRowMenu = ({
  handleOptionClick,
  handleCellClick,
  selectedCell,
  ...props
}) => {
  const anchor = React.useRef(null);
  const [isPopupVisible, setIsPopupVisible] = React.useState(false);

  React.useEffect(() => {
    setIsPopupVisible(selectedCell && props.id === selectedCell.id);
  }, [selectedCell, props.id]);

  const handleClick = () => {
    props?.setShow?.(false);
    if (isPopupVisible) {
      setIsPopupVisible(false);
      handleCellClick(null);
    } else {
      setIsPopupVisible(true);
      handleCellClick(props);
    }
  };

  React.useEffect(() => {
    const close = (e) => {
      if (e?.target?.role === "menu-grid") return;
      if (e?.target?.role !== "button") {
        setIsPopupVisible(false);
        handleCellClick(null);
      }
      if (!anchor.current) {
        setIsPopupVisible(false);
        handleCellClick(null);
      }
    };

    document.addEventListener("mousedown", close);

    return () => {
      document.removeEventListener("mousedown", close);
    };
  }, [handleCellClick]);

  return (
    <td className="cursor-pointer">
      <div>
        <div
          ref={anchor}
          role="menu-grid"
          onClick={handleClick}
          style={{
            boxShadow: "0px 0px 10px 2px rgba(0,0,0,0.1)",
            borderRadius: "10%",
            width: "25px",
            height: "20px",
          }}
          className={`d-flex justify-content-center align-items-center cursor-pointer p-1 m-1a ${styles["menu-hover"]}`}>
          <BsThreeDots role="menu-grid" />
        </div>
        <Popup
          show={isPopupVisible}
          anchor={anchor.current}
          anchorAlign={{ horizontal: "right", vertical: "bottom" }}
          popupAlign={{ horizontal: "right", vertical: "top" }}
          animate={false}
          popupClass={`${styles["popup-content"]}`}>
          <TransactionSearchOptionsList
            handleOptionClick={handleOptionClick}
            handleCellClick={handleCellClick}
            selectedCell={selectedCell}
            {...props}
          />
        </Popup>
      </div>
    </td>
  );
};
